import React, {useContext} from 'react';
import '../styles/styles.css';
import EnvCtx from "../contexts/EnvCtx";
import CameraCntx from "../contexts/CameraCntx";
import { useTranslation } from 'react-i18next'

const Mediazione = () => {
    const { cciaa } = useContext(EnvCtx);
    const { errore, mediazione, setSelectedMediazione, selectedIva, setSelectedIva, setShowErrorA, setShowErrorB, setShowErrorC, mediazioneDanger, setMediazioneDanger, showErrorPdf, setShowErrorPdf, getDescrizioneByLingua} = useContext(CameraCntx);
    const { t } = useTranslation();

    const handleSelectChange = (event) => {
        setSelectedMediazione(mediazione.find(item => item.descrizione === event.target.value));
        setShowErrorA(false);
        setShowErrorB(false);
        setShowErrorC(false);
        setShowErrorPdf(false);
        setMediazioneDanger(false);
    };

    const handleIvaButtonClick = (ivaOption) => {
        setSelectedIva(ivaOption);
    };

    return (
        <div key="mediazione-root">
            <p className="medi-p row mb-1 text-start">{t("preventivo")}</p>
            <div className="col-md-12">
                <label className="medi-label row mb-1 text-start"> {t("tipologia")} </label>
                {!errore && mediazione ? (
                    <select className={`medi-select form-select form-select-lg mb-3 ${(mediazioneDanger || showErrorPdf) ? 'border-danger' : ''}`} aria-label="Default select" onChange={handleSelectChange}>
                        <option disabled selected>{t("selectMediazione_message")}</option>
                        {mediazione.map((item, index) => (<option key={index} value={item.descrizione}>{getDescrizioneByLingua(item)}</option>))}
                    </select>
                ) : (
                    <select className={`form-select form-select-lg mb-3 sezione-select`} aria-label="Default select" disabled>
                        <option disabled selected>{t("selectMediazione_message")}</option>
                    </select>
                )}
            </div>

            <div className="container d-flex justify-content-center">
                <div className="row">
                    <div className="col-md-6">
                        <div className="d-flex justify-content-between">
                            <div
                                className={`border rounded p-2 d-flex justify-content-center align-items-center medi-option-button ${selectedIva === 'IVA_inclusa' ? 'medi-option-selected' : 'medi-option-unselected'}`}
                                onClick={() => handleIvaButtonClick('IVA_inclusa')}
                                style={selectedIva === 'IVA_inclusa' ? { backgroundColor: cciaa ? cciaa.background_colore : "" } : {}}
                            >
                                {t("iva_inclusa")}
                            </div>
                            <div
                                className={`border rounded p-2 d-flex justify-content-center align-items-center medi-option-button ${selectedIva === 'IVA_esclusa' ? 'medi-option-selected' : 'medi-option-unselected'}`}
                                onClick={() => handleIvaButtonClick('IVA_esclusa')}
                                style={selectedIva === 'IVA_esclusa' ? { backgroundColor: cciaa ? cciaa.background_colore : "" } : {}}
                            >
                                {t("iva_esclusa")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Mediazione;
